/**
 * Line icons for the comparison rows.
 *
 * Inline SVG rather than an icon package: seven glyphs do not justify a
 * dependency, and these inherit currentColor so they recolour with the row.
 * All are drawn on the same 24x24 grid with a 1.7 stroke so they sit at equal
 * visual weight — mixing stroke widths is what makes an icon set look bought
 * rather than designed.
 */
const PATHS = {
  // thermometer — environment sensing
  sensor: <path d="M14 14.76V4a2 2 0 1 0-4 0v10.76a4 4 0 1 0 4 0Z" />,

  // feed scoop
  feed: (
    <>
      <path d="M4.5 10h15l-1.4 8.8a2 2 0 0 1-2 1.7H7.9a2 2 0 0 1-2-1.7L4.5 10Z" />
      <path d="M8.5 10V7.5a3.5 3.5 0 0 1 7 0V10" />
    </>
  ),

  // clipboard — ingredient ledger
  ledger: (
    <>
      <rect x="5.5" y="4.5" width="13" height="16" rx="2" />
      <path d="M9.5 4.5V3.8a1.3 1.3 0 0 1 1.3-1.3h2.4a1.3 1.3 0 0 1 1.3 1.3v.7" />
      <path d="M9 10.5h6M9 14h6M9 17.5h3.5" />
    </>
  ),

  // egg — production
  egg: <path d="M12 3c3.2 0 5.8 4.4 5.8 8.4S15.2 20.8 12 20.8s-5.8-4.9-5.8-9.4S8.8 3 12 3Z" />,

  // pulse — mortality
  mortality: <path d="M3 12.2h3.6l2.6-7.4 3.9 14.6 2.6-7.2H21" />,

  // trend — weight & growth
  weight: (
    <>
      <path d="M3.5 16.8l5.6-5.6 3.4 3.4 6.4-6.4" />
      <path d="M14.4 8.2h4.5v4.5" />
    </>
  ),

  // shield check — vaccination
  vaccination: (
    <>
      <path d="M12 3.2l6.8 2.8v5.6c0 4.3-2.9 7.6-6.8 8.6-3.9-1-6.8-4.3-6.8-8.6V6L12 3.2Z" />
      <path d="M9.4 11.9l1.9 1.9 3.5-3.6" />
    </>
  ),
};

export default function ComparisonIcon({ name, className = '' }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {PATHS[name] ?? PATHS.ledger}
    </svg>
  );
}
